import { useState, useContext, useEffect, FormEvent } from 'react';
import { TextField, Button, Typography, Paper, Container, Box, Alert, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ProfileContext } from '../../ProfileContext';
import axios from 'axios';

export default function Profile() {
	const { profile, setProfile } = useContext(ProfileContext);

	const [name, setName] = useState('');

	const [currentPassword, setCurrentPassword] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');

	const [showCurrentPassword, setShowCurrentPassword] = useState(false);
	const [showNewPassword, setShowNewPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	const [message, setMessage] = useState('');
	const [error, setError] = useState('');

	useEffect(() => {
		if (profile) {
			setName(profile.name || '');
		}
	}, [profile]);

	const handleSubmitAll = async (e: FormEvent) => {
		e.preventDefault();
		setError('');
		setMessage('');

		if (!currentPassword || !newPassword || !confirmPassword) {
			setError('لطفاً تمامی فیلدهای مربوط به رمز عبور (فعلی، جدید و تکرار) را پر کنید.');
			return;
		}


		if (newPassword.length < 8) {
			setError('رمز عبور جدید باید حداقل ۸ کاراکتر باشد.');
			return;
		}


		if (newPassword !== confirmPassword) {
			setError('رمز عبور جدید با تکرار آن مطابقت ندارد.');
			return;
		}

		try {
			const token = localStorage.getItem('token');
			const headers = { Authorization: `Bearer ${token}` };


			const profileResponse = await axios.put('/profile', { name }, { headers });
			if (setProfile && profileResponse.data) {
				setProfile(profileResponse.data.data ?? profileResponse.data);
			}



			await axios.put('/user/change-password', {
				current_password: currentPassword,
				password: newPassword
			}, { headers });

			setCurrentPassword('');
			setNewPassword('');
			setConfirmPassword('');

			setMessage('تغییرات با موفقیت ذخیره شد');
		} catch (err: unknown) {
			setError('خطا در ذخیره اطلاعات. لطفا رمز عبور فعلی خود را بررسی کنید.');
		}
	};

	return (
		<Container maxWidth="sm" className="mt-8">
			<Paper className="p-6 flex flex-col gap-6">
				<Typography variant="h5">ویرایش پروفایل و رمز عبور</Typography>

				{message && <Alert severity="success">{message}</Alert>}
				{error && <Alert severity="error">{error}</Alert>}

				<Box component="form" onSubmit={handleSubmitAll} className="flex flex-col gap-4">
					<Typography variant="h6" className="text-sm font-bold">
						اطلاعات کاربری
					</Typography>

					<Typography className="text-sm font-bold">
						{name}
					</Typography>

					<hr className="my-2" />

					<Typography variant="h6" className="text-sm font-bold">تغییر رمز عبور</Typography>

					<TextField
						type={showCurrentPassword ? 'text' : 'password'}
						label="رمز عبور فعلی"
						value={currentPassword}
						onChange={(e) => setCurrentPassword(e.target.value)}
						fullWidth
						size="small"
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										onClick={() => setShowCurrentPassword(!showCurrentPassword)}
										edge="end"
									>
										{showCurrentPassword ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>

					<TextField
						type={showNewPassword ? 'text' : 'password'}
						label="رمز عبور جدید"
						value={newPassword}
						onChange={(e) => setNewPassword(e.target.value)}
						fullWidth
						size="small"
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										onClick={() => setShowNewPassword(!showNewPassword)}
										edge="end"
									>
										{showNewPassword ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>

					<TextField
						type={showConfirmPassword ? 'text' : 'password'}
						label="تکرار رمز عبور جدید"
						value={confirmPassword}
						onChange={(e) => setConfirmPassword(e.target.value)}
						fullWidth
						size="small"
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										onClick={() => setShowConfirmPassword(!showConfirmPassword)}
										edge="end"
									>
										{showConfirmPassword ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								</InputAdornment>
							),
						}}
					/>

					<Button type="submit" variant="contained" color="primary" className="mt-4">
						ذخیره همه تغییرات
					</Button>
				</Box>
			</Paper>
		</Container>
	);
}